export default __webpack_public_path__ + "static/media/vidimage.f46a870f.png";